import { Grid, Link, Typography } from '@mui/material';
import { type CaregiverSearchResultWithURL } from '@/types/SearchDirectory';
import { useResponsive } from '@/components/hooks/useResponsive';
import { CaregiverProfileAvatar } from './CaregiverProfileAvatar';
import { CaregiverHeader } from './CaregiverHeader';
import { CaregiverLocation } from './CaregiverLocation';
import { CaregiverRating } from './CaregiverRating';
import { CaregiverRate } from './CaregiverRate';
import { CaregiverExperienceInfo } from './CaregiverExperienceInfo';

export interface CaregiverOverviewProps {
  searchResult: CaregiverSearchResultWithURL;
}

export const CaregiverOverview = ({ searchResult }: CaregiverOverviewProps) => {
  const { isSmallViewport } = useResponsive();
  const bio = searchResult.caregiver.profiles?.commonCaregiverProfile?.bio;
  const reviewCount = searchResult.caregiverReviews?.length ?? 0;
  const hourlyRateFrom =
    searchResult.caregiver.profiles?.commonCaregiverProfile?.payRange?.hourlyRateFrom;
  const url = searchResult.profileURL;
  const targetValue = isSmallViewport ? undefined : '_blank';

  const {
    member: { address, displayName, isPremium },
    hasCareCheck,
    yearsOfExperience,
    hiredTimes,
    avgReviewRating,
  } = searchResult.caregiver;

  return (
    <Grid container columnSpacing={isSmallViewport ? 1.5 : 3}>
      <Grid item>
        <Link variant="h3" underline="none" href={url} target={targetValue}>
          <CaregiverProfileAvatar
            caregiver={searchResult.caregiver}
            isClientSearchResultsQuery={false}
          />
        </Link>
      </Grid>
      <Grid container item xs alignContent="flex-start">
        <Grid container item xs={9} alignContent="flex-start">
          <Grid item xs={12}>
            <Link
              color="text.primary"
              variant="h3"
              underline="none"
              href={url}
              target={targetValue}>
              <CaregiverHeader
                displayName={displayName}
                hasCareCheck={hasCareCheck}
                isPremium={isPremium}
              />
            </Link>
          </Grid>
          {!isSmallViewport && bio && (
            <Grid item xs={12}>
              <Typography variant="h4">{bio.title}</Typography>
            </Grid>
          )}
          {address && (
            <Grid item xs={12}>
              <CaregiverLocation address={address} />
            </Grid>
          )}
          {!!avgReviewRating && (
            <Grid item xs={12}>
              <CaregiverRating avgReviewRating={avgReviewRating} numberOfReviews={reviewCount} />
            </Grid>
          )}
        </Grid>
        {hourlyRateFrom && (
          <Grid item xs={3}>
            <CaregiverRate hourlyRateFrom={hourlyRateFrom} />
          </Grid>
        )}
        {yearsOfExperience > 0 && (
          <Grid item xs={12}>
            <CaregiverExperienceInfo
              yearsOfExperience={yearsOfExperience}
              hiredTimes={hiredTimes}
            />
          </Grid>
        )}
      </Grid>
    </Grid>
  );
};
